import AsyncStorage from '@react-native-async-storage/async-storage';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { RobotDevice } from '../types';
import { createRobotStore } from './create_store';
import { RobotState } from './types';

/**
 * This is the state store for the robot side of pixi.
 *
 * It is created using slices with the intention that it can be decomposed into multiple slices later if required.
 */
export const useRobotStateStore = create<RobotState>()(
  persist(
    immer<RobotState>(
      // Multiple stores can be combined here if required
      (...args) => ({
        ...createRobotStore(...args),
      })
    ),
    {
      name: 'robot-state',
      storage: createJSONStorage(() => AsyncStorage),
      // TODO: Add a hydrate callback that may automatically restablish connections with robots.

      /** This is where we select portions of state to store in persistent storage */
      partialize: (state) => ({
        robotDevices: Object.fromEntries(
          Object.entries(state.robotDevices).map(([id, robotDevice]) => {
            return [id, extractPeristedRobotFields(robotDevice)];
          })
        ),
      }),
    }
  )
);

const extractPeristedRobotFields = (robotDevice: RobotDevice) => {
  const result: any = {
    id: robotDevice.id,
    name: robotDevice.name,
    type: robotDevice.type,
  };

  if (robotDevice.websocketConnection) {
    result.websocketConnection = {
      ipAddress: robotDevice.websocketConnection.ipAddress,
    };
  }

  if (robotDevice.bluetoothConnection) {
    result.bluetoothConnection = {
      macAddress: robotDevice.bluetoothConnection.macAddress,
    };
  }

  return result;
};
